import React from 'react'
import StyledMenuIcon from './MenuIcon.styles'

export default function MenuIcon({ open }) {
    return (
        <StyledMenuIcon className={open ? 'open' : ''}>
            <span></span>
        </StyledMenuIcon>
    )
}
